export default __webpack_public_path__ + "8489cf703ea6e67adc4ed53b2bbc4430.png";